var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyevents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 178,
    viewBox: "0 0 151 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 167C116.921 167 150.5 133.421 150.5 92C150.5 50.5786 116.921 17 75.5 17C34.0786 17 0.5 50.5786 0.5 92C0.5 133.421 34.0786 167 75.5 167Z",
    fill: "#E6E6EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1981_115009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5 60H32.5C29.7386 60 27.5 62.2386 27.5 65V170C27.5 172.761 29.7386 175 32.5 175H118.5C121.261 175 123.5 172.761 123.5 170V65C123.5 62.2386 121.261 60 118.5 60Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 75H39.5C37.8431 75 36.5 76.3431 36.5 78C36.5 79.6569 37.8431 81 39.5 81H65.5C67.1569 81 68.5 79.6569 68.5 78C68.5 76.3431 67.1569 75 65.5 75Z",
    fill: "#E6E6EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 88H39.5C37.8431 88 36.5 89.3431 36.5 91C36.5 92.6569 37.8431 94 39.5 94H83.5C85.1569 94 86.5 92.6569 86.5 91C86.5 89.3431 85.1569 88 83.5 88Z",
    fill: "#DFEAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 102H39.5C37.8431 102 36.5 103.343 36.5 105C36.5 106.657 37.8431 108 39.5 108H65.5C67.1569 108 68.5 106.657 68.5 105C68.5 103.343 67.1569 102 65.5 102Z",
    fill: "#E6E6EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 115H39.5C37.8431 115 36.5 116.343 36.5 118C36.5 119.657 37.8431 121 39.5 121H83.5C85.1569 121 86.5 119.657 86.5 118C86.5 116.343 85.1569 115 83.5 115Z",
    fill: "#DFEAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 129H39.5C37.8431 129 36.5 130.343 36.5 132C36.5 133.657 37.8431 135 39.5 135H65.5C67.1569 135 68.5 133.657 68.5 132C68.5 130.343 67.1569 129 65.5 129Z",
    fill: "#E6E6EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 142H39.5C37.8431 142 36.5 143.343 36.5 145C36.5 146.657 37.8431 148 39.5 148H83.5C85.1569 148 86.5 146.657 86.5 145C86.5 143.343 85.1569 142 83.5 142Z",
    fill: "#DFEAFB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1981_115009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5 9H32.5C29.7386 9 27.5 11.2386 27.5 14V44C27.5 46.7614 29.7386 49 32.5 49H118.5C121.261 49 123.5 46.7614 123.5 44V14C123.5 11.2386 121.261 9 118.5 9Z",
    fill: "#D5D5DA"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 20H39.5C37.8431 20 36.5 21.3431 36.5 23C36.5 24.6569 37.8431 26 39.5 26H65.5C67.1569 26 68.5 24.6569 68.5 23C68.5 21.3431 67.1569 20 65.5 20Z",
    fill: "#E6E6EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 33H39.5C37.8431 33 36.5 34.3431 36.5 36C36.5 37.6569 37.8431 39 39.5 39H83.5C85.1569 39 86.5 37.6569 86.5 36C86.5 34.3431 85.1569 33 83.5 33Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1981_115009",
    x: 21.5,
    y: 51,
    width: 108,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1981_115009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1981_115009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1981_115009",
    x: 21.5,
    y: 0,
    width: 108,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1981_115009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1981_115009",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyevents);
export default __webpack_public_path__ + "static/media/emptyevents.b7ac6526b0da0f48b0121345540914d8.svg";
export { ForwardRef as ReactComponent };